import { getTracks, entityTrackEndpoint } from "@/config/endpoints";
import axiosInstance from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import type { EntityType, EntityTrack } from "../types/stageTypes";

/**
 * The tenant's tracks.
 *
 *   default            EVERY track — for CONFIG screens only (role editor, track
 *                      settings, automation builder), which must list a track
 *                      whether or not the person editing may use it.
 *   { viewable: true } only the tracks the VIEWER may see (server-filtered by
 *                      the track dial, `?scope=view`). Every user-facing picker
 *                      uses this: a Loan-team member dialled to Deny on the
 *                      other eleven tracks must not find them in a filter.
 *
 * Both keys start with "tracks-pipeline", so the existing track mutations'
 * invalidation refreshes them together.
 */
export default function useTracksPipeline(opts: { viewable?: boolean } = {}) {
  const viewable = Boolean(opts.viewable);
  const query = useQuery({
    queryKey: ["tracks-pipeline", viewable ? "view" : "all"],
    queryFn: async () => {
      const res = await axiosInstance.get(
        getTracks,
        viewable ? { params: { scope: "view" } } : undefined
      );

      return res.data?.tracks ?? [];
    },
  });

  return {
    tracks: query.data,
    length: query.data ? query.data.length : 0,
    isLoading: query.isLoading,
    error: query.error,
  };
}

export function useTracksByEntity(
  entityType: EntityType,
  entityId: string | number | null | undefined
) {
  const query = useQuery<EntityTrack[]>({
    queryKey: ["entity-tracks", entityType, entityId],
    queryFn: async () => {
      const res = await axiosInstance.get(
        `${entityTrackEndpoint}/${entityType}/${entityId}`
      );
      return res.data?.tracks ?? [];
    },
    enabled: !!entityId,
  });
  console.log(query.data, "entity tracks");

  return {
    tracks: query.data ?? [],
    activeTracks: (query.data ?? []).filter((t) => t.isActive),
    availableTracks: (query.data ?? []).filter((t) => !t.isActive),
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
